/**
 * Utility functions for handling string values from API responses
 */

/**
 * Internal helper to check if a string is empty (null, undefined, empty, or only whitespace)
 */
const isEmpty = (value?: string | null): boolean => {
  return value == null || value.trim().length === 0;
};

/**
 * Checks if a string has meaningful content (not null, undefined, empty, or only whitespace)
 */
export const hasContent = (value?: string | null): boolean => {
  return !isEmpty(value);
};

/**
 * Normalizes a string value by treating null, undefined, and whitespace-only strings as empty strings
 */
export const normalizeString = (value?: string | null): string => {
  return isEmpty(value) ? '' : value!;
};

/**
 * Normalizes a string value and returns null if it's effectively empty
 */
export const normalizeStringOrNull = (value?: string | null): string | null => {
  return isEmpty(value) ? null : value!;
};
